import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row items-center justify-end q-gutter-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")
  const _component_q_btn = _resolveComponent("q-btn")
  const _component_q_date = _resolveComponent("q-date")
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")
  const _component_q_input = _resolveComponent("q-input")
  const _directive_close_popup = _resolveDirective("close-popup")

  return (_openBlock(), _createBlock(_component_q_input, {
    modelValue: _ctx.date,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.date = $event)),
    "bottom-slots": true,
    "label-slot": true,
    clearable: true,
    dense: true,
    autofocus: _ctx.autofocus,
    color: "primary",
    onKeyup: _cache[5] || (_cache[5] = _withKeys(_withModifiers(($event: any) => (_ctx.inputValue()), ["stop"]), ["enter"]))
  }, {
    label: _withCtx(() => [
      _createVNode("span", null, _toDisplayString(_ctx.$t('widgetSelectADate')), 1)
    ]),
    prepend: _withCtx(() => [
      _createVNode(_component_q_icon, { name: "event" })
    ]),
    after: _withCtx(() => [
      _createVNode(_component_q_btn, {
        icon: "send",
        flat: true,
        color: "primary",
        round: true,
        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.inputValue()), ["stop"]))
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_q_popup_proxy, {
        ref: "qDateProxy",
        "transition-show": "scale",
        "transition-hide": "scale",
        onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(() => {}, ["stop"]), ["enter"]))
      }, {
        default: _withCtx(() => [
          _createVNode("div", null, [
            _createVNode(_component_q_date, {
              modelValue: _ctx.proxyDate,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.proxyDate = $event)),
              landscape: _ctx.$q.screen.name !== 'xs',
              onBeforeShow: _ctx.updateProxy
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_1, [
                  _withDirectives(_createVNode(_component_q_btn, {
                    flat: true,
                    color: "primary",
                    label: _ctx.$t('widgetCancel')
                  }, null, 8, ["label"]), [
                    [_directive_close_popup]
                  ]),
                  _withDirectives(_createVNode(_component_q_btn, {
                    flat: true,
                    color: "primary",
                    label: _ctx.$t('widgetOk'),
                    onClick: _ctx.save
                  }, null, 8, ["label", "onClick"]), [
                    [_directive_close_popup]
                  ])
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "landscape", "onBeforeShow"])
          ])
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["modelValue", "autofocus"]))
}